<template>
    <div class="row">
        <div class="col-sm-12">
             <div v-if="successMessage" class="alert alert-success">{{ successMessage }}</div>
             <div v-if="errorMessage" class="alert alert-danger">{{ errorMessage }}</div>
              <div class="ix-table-box">
                <table class="ix-table ix-table-sm">
                    <thead>
                        <tr>
                            <th>Désignation</th>
                            <th>Référence</th>
                            <th>Taux horaire</th>
                            <th></th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr v-for="(equipment, index) in equipments" :key="index" v-show="!savedEquipmentLoading">
                            <td>
                                <a :href="showEquipmentRoute + '/' + equipment.id" class="ix-link">{{ equipment.name }}</a>
                            </td>
                            <td>
                                {{ equipment.number }}
                            </td>
                            <td>
                                <span v-if="equipment.hourly_rate">{{ currency(equipment.hourly_rate) }}</span>
                            </td>
                            <td class="text-right">
                                <button type="button" class="ix-btn danger ix-btn-small" @click="removeRow(index)" v-if="equipments.length">
                                    <i class="far fa-trash"></i>
                                </button>
                            </td>
                        </tr>
                        <tr v-if="loading">
                            <td colspan="4" class="text-center">
                                <i class="far fa-circle-notch fa-spin"></i>
                            </td>
                        </tr>
                        <tr v-if="!loading && equipments && equipments.length == 0">
                             <td colspan="4" class="text-center">
                                <div class="alert alert-info">Aucun équipement associé à ce poste de travail.</div>
                            </td>
                        </tr>
                        <tr v-show="!loading">
                            <td colspan="4">
                                <input placeholder="Commencer la saisie pour obtenir des suggestions .." class="form-control" id="equipmentSearchInput" type="text" v-model="equipment">
                            </td>
                        </tr>
                      
                    </tbody>
                </table>

               
            </div>

             <div class="mt-2 d-flex justify-content-between">
                <button type="button" class="ix-btn green ix-btn-small" @click="submit" :disabled="savedEquipmentLoading">
                    <i class="far fa-circle-notch fa-spin" v-if="savedEquipmentLoading"></i> Enregistrer
                </button>
            </div>
        </div>
    </div>
  
</template>

<script>
export default {
    name: 'EquipmentStationTable',
    props: ['equipmentUrl', 'showEquipmentRoute', 'exclude', 'syncEquipmentsUrl', 'dataUrl'],
     data() {
            return {
                loading: true,
                equipment: null,
                equipments: [],
                savedEquipmentLoading: false,
                successMessage: null,
                errorMessage: null
            };
        },
    methods: {
        addRow(item) {
           this.equipments.push(item);
           this.equipment = null;
        },
        removeRow(index) {
            this.equipments.splice(index, 1)
        }, 
        submit: async function() {
            // TODO: Implement submission logic
            this.savedEquipmentLoading = true;
            const selectedIds = this.getCurrentSelectedEquipementsId();
            fetch( this.syncEquipmentsUrl, {
                method: 'POST',
                headers: this.getHttpJsonRequestHeaders().headers,
                body: JSON.stringify({'equipment_ids': selectedIds})
            }).then(response => response.json())
              .then(data => {
                    this.equipments = data.equipments;
                    this.errorMessage = null;
                    this.successMessage = 'Équipements enregistrés avec succès';
                    this.savedEquipmentLoading = false;
                    setTimeout(() => {
                        this.successMessage = null;
                    }, 5000);
              }).catch((reason) => {
                this.savedEquipmentLoading = false;
                this.successMessage = null;
                this.errorMessage = 'Erreur lors de l\'enregistrement des équipements';
                setTimeout(() => {
                    this.errorMessage = null;
                }, 5000);
              });
        },
        getCurrentSelectedEquipementsId: function() {
            return this.equipments.map(equipment => equipment.id);
        },  
        getData: async function() {
            fetch(this.dataUrl, {
                ...{
                    method: 'GET'
                },
                ...this.getHttpJsonRequestHeaders()
            }).then((response) => {
                return response.json();
            }).then((data) => {
                if (data && data.equipments && data.equipments.length) {
                    this.equipments = data.equipments;
                }

                this.loading = false;
            });
        }
    },
    async mounted(){
        await this.getData();
        $("#equipmentSearchInput").autocomplete({
                minLength: 0,
                source: (request, response) => {
                    $.ajax({
                        url : this.equipmentUrl,
                        type: 'get',
                        dataType : 'json',
                        headers: this.getHttpJsonRequestHeaders().headers,
                        data: { q: request.term, 'company_id_null': 1 ,'!id': this.getCurrentSelectedEquipementsId().join(';') + (this.exclude != undefined ? (';' + this.exclude) : '') },
                        success: (data) => {
                            response($.map(data, (item) => {
                                return Object.assign(item, {
                                    label: item.name,
                                    value: item.name
                                })
                            }))
                        }
                    });
                },
                create: function () {
                    $(this).data('ui-autocomplete')._renderItem = function (ul, item) {
                        const formattedRate = item.hourly_rate
                            ? new Intl.NumberFormat('fr-FR', { style: 'currency', currency: 'EUR' }).format(item.hourly_rate)
                            : 'Non renseigné';

                        var html = `<div class="d-flex align-items-center">
                                      <span>${item.name}</span>
                                      <span class="ml-auto badge badge-secondary">${formattedRate}</span>
                                    </div>
                                    <span class="ml-2 ix-state bordered">${item.number ?? 'Non renseigné'}</span>`;

                        return $('<li>')
                            .append(html)
                            .appendTo(ul);
                    };
                },
                change: (e, item) => {
                    if(!item.item){          
                        $(e.target).val("");
                        this.equipment = null
                    }
                },
                select: (e, item) => {
                    if (item.item) {
                        this.addRow(item.item)
                        $(e.target).val("")
                        this.company = null
                    }
                },
            }).focus(() => {
                $("#equipmentSearchInput").autocomplete("search", '');
        });

    }
}
</script>

<style scoped>
</style>
